<template>
  <div>

     <v-snackbar v-model="successSnack" :timeout="3000" top color="white">
        <span class="green--text">{{sucMsg}}</span>
      </v-snackbar>
    
    <!-- Navigation bar -->
    <div class="container pa-0">
      <nav class="navbar navbar-expand-lg navbar-light">
        <a class="navbar-brand" href="#">
          <img
            src="/logo.png"
            width="60"
            height="40"
            class="d-inline-block align-top "
            alt="logo"
            loading="lazy"
          />
        </a>

        <button
          class="navbar-toggler"
          type="button"
          data-toggle="collapse"
          data-target="#navbarSupportedContent"
          aria-controls="navbarSupportedContent"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span class="navbar-toggler-icon"></span>
        </button>

        <div class="collapse navbar-collapse" id="navbarSupportedContent">
          <!-- First UL List -->
          <ul class="navbar-nav mr-auto py-4 py-md-0">
            <li class="nav-item px-lg-2 py-1">
              <a class="nav-link" href="#home"
                >Home <span class="sr-only">(current)</span></a
              >
            </li>
            <li class="nav-item px-lg-2 py-1">
              <a class="nav-link" href="#about">About</a>
            </li>
            <li class="nav-item px-lg-2 py-1">
              <a class="nav-link" href="#products">Products</a>
            </li>
            <li class="nav-item px-lg-2 py-1">
              <a class="nav-link" href="#contact">Contact</a>
            </li>
          </ul>

          <!-- Second Ul list -->
          <ul class="navbar-nav ml-auto">
            <li class="nav-item px-lg-2 py-1">
              <router-link class="nav-link" to="/login" v-if="Logged === false">Login</router-link>
            </li>
             <li class="nav-item px-lg-2 py-1">
              <a class="nav-link" @click="DashboardRoute()" v-if="Logged=== true" >Dashboard</a>
            </li>
            <li class="nav-item px-lg-2 py-1">
              <router-link class="nav-link" to="/register"
                 v-if="Logged === false">Register</router-link
              >
            </li>
          </ul>
        </div>
    </nav>
    </div>

    <main>
      <!-- End of navigation bar -->

      <!-- Section One -->
      <section id="home" class="home-section">
        <div class="container pb-5">
          <div class="row">
            <div class="col-lg-6">
              <h1 style="color: white; margin-top: 100px;">
                Let's Farm for you
              </h1>
              <p class="mt-3" style="color: white;">
                We provide a guaranteed wide range of high yielding agro
                investment opportunities across the agricultural sector value
                chain from farming, realestate etc...
              </p>
              <button @click="getStarted()" class="btn btn-green mt-2">Get Started</button>
            </div>
            <div class="col-lg-6">
              <!-- <img src="https://themes91.in/wp/theme-demo/cultivation/assets/images/vehicle.png" class="img-fluid" alt="" /> -->
            </div>
          </div>
        </div>
      </section>

      <!-- section two -->
      <section
        id="about"
        class="pt-5 pb-5"
        data-aos="fade-up"
        data-aos-duration="3000"
        style="background: linear-gradient(180deg, #FFFFFF 24.36%, #F7F7F7 93.67%);"
      >
        <div class="container">
          <div class="row">
            <div class="col-lg-6">
              <img
                class="img-fluid"
                src="https://images.unsplash.com/photo-1464226184884-fa280b87c399?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=500&q=60"
                alt="about"
              />
            </div>
            <div class="col-lg-6">
              <p class="text-color">GREEN FARMS</p>
              <h3>About Us</h3>
              <p>
                We are on a mission of solving global food crisis by providing
                sustainable solution and support that aids convenience and
                accessibility for farmers, investors and consumers.
              </p>
              <p>
                Green Farms is a safe and secured investment platform with
                guaranteed Returns on investment as high as 40%,
                <span style="font-weight: bold; color: #48c074;"
                  >START INVESTING NOW!!!</span
                >
              </p>
              <ul style="list-style: none; display: flex;">
                <li>
                  <i class="mdi mdi-check icon-color"></i>
                  Affordability
                </li>
                <li style="margin-left: 40px;">
                  <i class="mdi mdi-check icon-color"></i>
                  Competency
                </li>
              </ul>
              <ul style="list-style: none; display: flex;">
                <li>
                  <i class="mdi mdi-check icon-color"></i>
                  Reliability
                </li>
                <li style="margin-left: 60px;">
                  <i class="mdi mdi-check icon-color"></i>
                  Integrity
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      <!-- products section -->
      <section
        id="products"
        class="pb-5 pt-5"
        style="background: linear-gradient(180deg, #FFFFFF 24.36%, #F7F7F7 93.67%);"
      >
        <div class="container">
          <h3 class="text-color">Fund A Farm</h3>
          <p>
            You can Fund a farm and earn maximum interest plus capital in the
            shortest possible time, this is the fastest way of growing wealth.
            Fund a Farm today
          </p>
          <div class="row mt-4" data-aos="fade-up"
        data-aos-duration="3000">
            
           <div class="col-lg-3 mb-3"  v-for="n in Farms" :key="n.name">
                <div class="card product">
                <div class="card-body card-product">
                    <div class="text-center">
                        <!-- <img width="200" height="200" :src="n.farm_img_url" /> -->
                        <v-img :src="getImageUrl(n.farm_img_url)" height="173.95"></v-img>
                    </div>
                    <h5 class="card-title text-center mt-5">{{n.name}}</h5>
                    <h6 class="card-text mx-4 mt-5 text-color">Duration: <span style="font-weight: bold;">{{n.duration}}</span> </h6>
                    <h6 class="card-text mx-4 text-color mt-3">Cost: <span style="font-weight: bold;">&#8358;{{n.cost}}</span></h6>
                    <h6 class="card-text mx-4 text-color mt-3">ROI:  <span style="font-weight: bold;">{{n.roi}}%</span></h6>
                    <div class="text-center mt-5 mb-4">
                        <button class="btn btn-green"  @click="FundFarm($event, n._id)">Get Started</button>
                    </div> 
                </div>
                </div>
            </div>

          </div>

            
        </div>
      </section>

      <!-- section three Services Page design -->

      <!-- <section id="services" class="pt-5 pb-5" style="background: linear-gradient(180deg, #FFFFFF 24.36%, #F7F7F7 93.67%);" >
      <div class="container">
        <h3 class="text-color text-center">Services</h3>
        <p class="text-center">Green Farms offer the following services with excellence
        </p>
        <div class="row mt-4">
            <div class="col-lg-4 mb-3">
              <div class="card card-home">
                <div class="card-body">
                    <div class="text-center mt-3">
                      <img src="https://themes91.in/wp/cultivation/cultivation-home2/wp-content/uploads/sites/3/2019/06/home2-ser5.png" class="img-fluid" alt="third" />
                    </div>
                    <h5 class="text-center card-text mt-4">Fund a farm</h5>
                    <p class="text-center mt-3">Lorem ipsum dolor sit amet consectetur adipisicing elit.</p>
                </div>
              </div>
            </div>
            <div class="col-lg-4 mb-3">
              <div class="card card-home">
                <div class="card-body">
                    <div class="text-center mt-3">
                      <img src="https://cdn.shortpixel.ai/client/q_lossy,ret_img/https://themes91.in/wp/cultivation/cultivation-home2/wp-content/uploads/sites/3/2019/06/agriculture-64x64.png" class="img-fluid" alt="third" />
                    </div>
                    <h5 class="text-center card-text mt-4">Own a farm</h5>
                    <p class="text-center mt-4">Lorem ipsum dolor sit amet consectetur adipisicing elit. </p>
                </div>
              </div>
            </div>
            <div class="col-lg-4">
              <div class="card card-home">
                <div class="card-body">
                    <div class="text-center mt-3">
                      <img src="https://cdn.shortpixel.ai/client/q_lossy,ret_img/https://themes91.in/wp/cultivation/cultivation-home2/wp-content/uploads/sites/3/2019/06/home2-ser3.png " class="img-fluid" alt="third" />
                    </div>
                    <h5 class="text-center card-text mt-4">Rent a farm</h5>
                    <p class="text-center mt-3">Lorem ipsum dolor sit amet consectetur adipisicing elit.  </p>
                </div>
              </div>
            </div>
        </div>
      </div>
    </section> -->
      <!--End of services section  -->

      <!-- section four -->
      <section class="pt-5 pb-5">
        <div class="container">
          <div class="row">
            <div class="col-lg-6">
              <img
                src="https://agbeloba.ng/_nuxt/img/1%204868006Illustration.d73ec23.png"
                class="img-fluid"
                alt="ll"
              />
            </div>
            <div class="col-lg-6">
              <p class="mt-5 text-color">GREEN FARMS</p>
              <h3>Taking Agricultural Investment To A New Level</h3>
              <p>
                Earn
                guaranteed returns by investing in different crops over a
                specified period of time.
              </p>
              <button @click="startInvest()" class="btn btn-green mt-2">Start Investing</button>
            </div>
          </div>
        </div>
      </section>

      <section id="team" class="pt-5 pb-5" style="background: #F5F7FA;">
        <div class="container">
          <p>Team</p>
          <h3 class="text-color mt-n3">Our Team Members</h3>
          <div class="row mt-5">
            <div class="col-lg-3 mb-3">
              <div class="card">
                <div class="card-body team-card">
                  <img
                    src="/ada.png"
                    class="card-img-top"
                    alt="team1"
                  />
                  <h5 class="card-title text-color text-center mt-4">Ada Nduka Oyom</h5>
                  <p class="text-center">Founder</p>
                </div>
              </div>
            </div>
            <div class="col-lg-3 mb-3">
              <div class="card">
                <div class="card-body team-card">
                  <img
                    src="/idris.jpg"
                    class="card-img-top"
                    alt="team1"
                  />
                  <h5 class="card-title text-color text-center mt-4">Idris Olubisi</h5>
                  <p class="text-center">SCA Mentor</p>
                </div>
              </div>
            </div>
            <div class="col-lg-3 mb-3">
              <div class="card">
                <div class="card-body team-card">
                  <img
                    src="/lola.jpg"
                    class="card-img-top"
                    alt="team1"
                  />
                  <h5 class="card-title text-center text-color mt-4">Omolola Omolambe</h5>
                  <p class="text-center">Developer</p>
                </div>
              </div>
            </div>
            <div class="col-lg-3">
              <div class="card">
                <div class="card-body team-card">
                  <img
                    src=" https://res.cloudinary.com/dmnghlyic/image/upload/v1569590672/praise_mfcnbm.jpg "
                    class="card-img-top"
                    alt="team1"
                  />
                  <h5 class="card-title text-color text-center mt-4">Akande Oremei</h5>
                  <p class="text-center">Developer</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <!-- section five -->
      <section id="contact" class="pt-5 pb-5">
        <div class="container">
          <h3 class="text-color text-center">Contact Us</h3>
          <p class="text-center">
            Drop us a message for any query, We would love to hear from you.
          </p>
          <!-- form submission -->
          <form class="mt-4" ref="form">
            <!-- first row -->
            <div class="row">
              <div class="col-lg-6 mt-2">
                <img
                  src="https://images.unsplash.com/photo-1473186505569-9c61870c11f9?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=500&q=60"
                  class="img-fluid"
                />
              </div>
              <div class="col-lg-6">
                <div class="form-group">
                  <label for="email">Email</label>
                  <input
                    type="email"
                    class="form-control input-style"
                    id="email"
                    required
                    v-model="email"
                    v-bind:class="{'form-control' : true, 'is-invalid' : !validEmail(email) && emailBlured}"
                    v-on:blur="emailBlured = true"
                  />
                   <div class="invalid-feedback">A valid email is required</div>
                </div>
                <div class="form-group mt-2">
                  <label for="subject">Subject</label>
                  <input
                    type="text"
                    class="form-control input-style"
                    id="subject"
                    v-model="subject"
                     v-bind:class="{'form-control' : true, 'is-invalid' : !validSubject(subject) && subjectBlured}"
                    v-on:blur="subjectBlured = true"
                  />
                  <div class="invalid-feedback">This field is required</div>
                </div>
                <div class="form-group mt-2">
                  <label for="message">Your message</label>
                  <textarea
                    class="form-control input-style"
                    id="message"
                    rows="5"
                    v-model="message"
                     v-bind:class="{'form-control' : true, 'is-invalid' : !validMessage(message) && messageBlured}"
                    v-on:blur="messageBlured = true"
                  ></textarea>
                   <div class="invalid-feedback">This field is required</div>
                </div>
                <!-- submit button -->
                <div class="text-center mt-4">
                  <button :disabled="loading" @click="SendMessage($event)" class="btn btn-green">Send Message
                    <span class="fa fa-circle-o-notch fa-spin" v-if="loading"></span>
                  </button>
                </div>
              </div>
            </div>
          </form>
        </div>
      </section>
    </main>

    <!-- Footer -->
    <footer style="background: #033953; padding-bottom: 20px;" class="mt-5">
      <div class="container pt-5">
        <div class="row">
          <div class="col-lg-4 col-sm-12">
            <h6 style="color: #1dbf73;">Green Farms</h6>
            <p style="color: white; font-size: 14px;">
              We are on a mission of solving global food crisis by providing
              sustainable solution and support that aids convenience and
              accessibility for farmers, investors and consumers.
            </p>
          </div>

          <div class="col-lg-4 col-sm-12">
            <h6 style="color: #1dbf73;">Contact Info</h6>
            <p style="color: white; font-size: 13px;">
              7321 N Paulina St, Chicago, IL. 60626.<br />
              +1 (312) 774-9047
            </p>
          </div>
          <div class="col-lg-4 col-sm-12">
            <h6 style="color: #1dbf73;">Connect with us.</h6>
            <ul style="display: flex; list-style: none;">
              <li>
                <a href="#" style="color: white;"
                  ><i class="fab fa-twitter"></i
                ></a>
              </li>
              <li style="margin-left: 20px;">
                <a href="#" style="color: white;"
                  ><i class="fab fa-facebook"></i
                ></a>
              </li>
              <li style="margin-left: 20px;">
                <a href="#" style="color: white;"
                  ><i class="fab fa-instagram"></i
                ></a>
              </li>
              <li style="margin-left: 20px;">
                <a href="#" style="color: white;"
                  ><i class="mdi mdi-email"></i
                ></a>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div class="container mt-3 text-center">
        <p style="color: white; font-size: 14px;">
          &copy; All rights Reserved Green Farms 2020.
        </p>
      </div>
    </footer>

    <!-- footer -->
    <!-- <footer style="background: #1b6983; padding-bottom: 20px;" class="">

      <div class="container pt-5">
        <div class="row">
          <div class="col-lg-4 col-sm-12">
            <h6 style="color: white;">Our Information</h6>
            <p style="color: white; font-size: 13px;">Adesuwa street, 67 road, Magento.</p>
          </div>

            <div class="col-lg-4 col-sm-12">
              <h6 style="color: white;">Our Correspondence</h6>
              <p style="color: white; font-size: 13px;">+234 9055055016</p>
            </div>
            <div class="col-lg-4 col-sm-12">
              <h6 style="color: white;">Connect with us.</h6>
              <ul style="display: flex; list-style: none;" class="pl-0">
                <li><a href="https://t.me/officialcashflow" target="_blank" style="color: white;"><i class="fab fa-telegram"></i></a></li>
                <li style="margin-left: 20px;"><a href="#" target="_blank" style="color: white;"><i class="fab fa-facebook"></i></a></li>
                <li style="margin-left: 20px;"><a href="#" target="_blank" style="color: white;"><i class="fab fa-instagram"></i></a></li>
                <li style="margin-left: 20px;"><a href="mailto:support@cashflow.com" target="_blank" style="color: white;"><i class="mdi mdi-email"></i></a></li>
              </ul>
            </div>
        </div>
      </div>
      
      <div class="container mt-3 text-center">
          <p style="color: white; font-size: 14px;">&copy; All rights Reserved Cashflow Network {{ new Date().getFullYear() }}.</p>
      </div>
    </footer> -->
    <!-- back to top -->
    <v-btn
      v-scroll="onScroll"
      v-show="fab"
      fab
      dark
      fixed
      bottom
      right
      color="#48c074"
      @click="toTop"
    >
      <v-icon>mdi-arrow-up</v-icon>
    </v-btn>
  </div>
</template>

<script>
export default {
  data() {
    return {
      fab: false,
      email: '',
      emailBlured: false,
      subjectBlured: false,
      messageBlured: false,
      subject: '',
      message: '',
      valid: false,
      valid1: false,
      valid2: false,
      loading: false,
      successSnack: false,
      sucMsg: ''
    };
  },
  computed:{
     Farms(){
        return this.$store.state.farm.homefarms
      },
      Logged(){
        return this.$store.state.auth.isUserLogged
      },
      adminLogged(){
        return this.$store.state.auth.isAdminLogged
      },
  },
  methods: {
     validate: function(){
      this.emailBlured = true;
      if(this.validEmail(this.email)){
        this.valid = true
      }
    },
    validateSubject: function(){
      this.subjectBlured = true;
      if(this.validSubject(this.subject)){
        this.valid1 = true
      }
    },
    validateMessage: function(){
      this.messageBlured = true;
      if(this.validMessage(this.message)){
        this.valid2 = true
      }
    },
    validEmail: function(email){
      var re = /(.+)@(.+){2,}\.(.+){2,}/;
      return re.test(email.toLowerCase())
    },
    validSubject: function(subject){
      return subject
    },
    validMessage: function(message){
      return message
    },
    onScroll(e) {
      if (typeof window === "undefined") return;
      const top = window.pageYOffset || e.target.scrollTop || 0;
      this.fab = top > 20;
    },
    toTop() {
      this.$vuetify.goTo(0);
    },
    getImageUrl(url){
            return url
        },
    FundFarm(event, id){
        event.preventDefault()
        if(this.Logged === true){
          this.$store.dispatch("GetFarmsById", id)
          .then((success)=>{
              this.$router.push(`/farms/${success.data._id}`)
          })
          .catch(()=>{
          })
        }else{
          this.$router.push(`/login`)
        }    
    },
    getStarted(){
      // users route
       if(this.Logged === true  && this.adminLogged === false){
        this.$store.dispatch("GetFarms")
          .then(()=>{
              this.$router.push(`/farms`)
          })
          .catch(()=>{
          })
        }
        // admin route
        else if(this.Logged === true  && this.adminLogged === true){
          this.$store.dispatch("GetFarms")
          .then(()=>{
              this.$router.push(`/farms/admin`)
          })
          .catch(()=>{
          })
        }
        else{
          this.$router.push(`/register`)
        }   
    },
    SendMessage(event){
      event.preventDefault()
      this.validate();
      this.validateSubject()
      this.validateMessage()
       if(this.valid == true && this.valid1 ==true && this.valid2 == true){
         this.loading = true
          this.$store.dispatch("ContactUs", {
          "email":  this.email,
          "subject": this.subject,
          "body": this.message
        })
        .then(()=>{
          this.loading = false
          this.successSnack = true,
          this.sucMsg = 'Message successfully sent',
          this.email = ''
          this.subject = ''
          this.message = ''
          this.emailBlured = false
          this.subjectBlured = false
          this.messageBlured = false
        })
        .catch(()=>{
          this.loading = false
        })
       }
    },
    startInvest(){
         // users route
       if(this.Logged === true  && this.adminLogged === false){
        this.$store.dispatch("GetFarms")
          .then(()=>{
              this.$router.push(`/farms`)
          })
          .catch(()=>{
          })
        }
        // admin route
        else if(this.Logged === true  && this.adminLogged === true){
          this.$store.dispatch("GetFarms")
          .then(()=>{
              this.$router.push(`/farms/admin`)
          })
          .catch(()=>{
          })
        }
        else{
          this.$router.push(`/login`)
        }
    },
    DashboardRoute(){
     if(this.Logged === true && this.adminLogged === false){
       this.$router.push('/dashboard')
     }
     if(this.Logged === true && this.adminLogged === true){
       this.$router.push('/dashboard/admin')
     }
      
    }
  },
  created(){
     this.$store.dispatch("HomeFarm")
        .then(()=>{
        })
        .catch(()=>{
        })
  }
};
</script>

<style scoped>
.v-application ul {
  padding: 0px;
}

body {
  scroll-behavior: smooth;
  font-family: "Work Sans";
}

/* navigation styles */

.nav-item:after {
  position: absolute;
  bottom: -5px;
  left: 40px;
  width: 5px;
  border-radius: 50%;
  height: 5px;
  content: "";
  background-color: #48c074;
  opacity: 0;
  transition: all 200ms linear;
}
.nav-item:hover:after {
  bottom: 0;
  opacity: 1;
}
.nav-item.active:hover:after {
  opacity: 0;
}
.nav-item {
  position: relative;
  transition: all 200ms linear;
}

.navbar-toggler {
  float: right;
  border: none;
  padding-right: 0;
}
.navbar-toggler:active,
.navbar-toggler:focus {
  outline: none;
}
.navbar-light .navbar-toggler-icon {
  width: 24px;
  height: 17px;
  background-image: none;
  position: relative;
  border-bottom: 1px solid #777;
  transition: all 300ms linear;
}
.navbar-light .navbar-toggler-icon:after,
.navbar-light .navbar-toggler-icon:before {
  width: 24px;
  position: absolute;
  height: 1px;
  background-color: #777;
  top: 0;
  left: 0;
  content: "";
  z-index: 2;
  transition: all 300ms linear;
}
.navbar-light .navbar-toggler-icon:after {
  top: 8px;
}
.navbar-toggler[aria-expanded="true"] .navbar-toggler-icon:after {
  transform: rotate(45deg);
}
.navbar-toggler[aria-expanded="true"] .navbar-toggler-icon:before {
  transform: translateY(8px) rotate(-45deg);
}
.navbar-toggler[aria-expanded="true"] .navbar-toggler-icon {
  border-color: transparent;
}

/* main styles */

.home-section {
  background-image: linear-gradient(rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.6)),
    url("https://images.unsplash.com/photo-1529313780224-1a12b68bed16?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9");
  background-size: cover;
  background-repeat: no-repeat;
  height: 500px;
}

.text-color {
  color: #033953;
}

.icon-color {
  color: #48c074;
  font-size: 20px;
}

.main-color {
  background-color: #48c074;
  color: #fff;
}
.btn-green {
  background: #48c074;
  border-radius: 38.5px;
  color: #fff;
  padding: 10px 25px;
  transition: all 0.5s;
}
.btn-green:hover {
  background: #fff;
  box-shadow: 0px -2px 10px rgba(255, 255, 255, 0.14),
    0px 4.5px 10px rgba(255, 255, 255, 0.14);
  color: #48c074;
  border: 1px solid #48c074;
}
.input-style {
  padding: 20px 20px;
}
.input-style:focus {
  border-color: rgba(50, 54, 67, 0.2);
  box-shadow: 0px 5px 30px rgba(50, 54, 67, 0.2);
  outline: 0 none;
}
.card {
  border: 0;
}
.product {
  border: 0;
  transition: all ease-in-out 0.6s;
}
.card-home {
  height: 250px;
}
.card-product {
  background-color: #fff;
  border-radius: 5px;
  box-shadow: 0 5px 11px 0 rgba(0, 0, 0, 0.18), 0 4px 15px 0 rgba(0, 0, 0, 0.15);
}
.product:hover {
  transform: scale(1.07);
  transition: all ease-in-out 0.6s;
}
.team-card {
  background-color: #fff;
  border-radius: 5px;
}
</style>
